import { useState, useEffect, Fragment} from "react";
import Navbar from "../../Components/Navbar";
import { Card, Button, Modal, Form } from "react-bootstrap";
import "./style.css";
import { useAuthContext } from "../../hooks";
import { getOrgUserDetails } from "../../api/users/getOrgUserDetails";
import { updateUserProfile } from "../../api/users/updateProfile";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MyProfileSc from "./index.sc";
import AWS from 'aws-sdk';
function Index() {
  const [user, setUser] = useState<any>([]);
  const auth = useAuthContext();
  const fetchOrgUser = async () => {
    const orgId = auth?.userInfo?.orgs?.[0]?.id;
    const orgUserId = auth?.userInfo?.orgs_user_id?.[0];
    if (orgId == null || orgUserId == null) return;
    setUser(await getOrgUserDetails(orgId, String(orgUserId)));
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const handleEdit = async (e: any) => {
    console.debug("data > ", e);
    await updateUserProfile(auth?.userInfo?.id, {
      ...e,
    })
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
    fetchOrgUser();
  };

  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handleEdit(e);
    reset();
    setShow(false);
  };
  useEffect(() => {
    fetchOrgUser();
  }, []);
  console.log(auth?.userInfo?.email,"email");
  const navbarFunc = () => {
    return auth?.userInfo?.is_admin;
  };
  const setState = navbarFunc();
  console.log("userNavbar", setState);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  return (
    <MyProfileSc>
      <div className="personal-details">
        <div className="personal-details-main">
          {user?.map((data: any,idx:any) => {
            return (
              <Fragment key ={idx}>
                <div className="profile-details">
                  <p className="profile-name">
                    {data?.first_name + " " + "" + data?.last_name}
                  </p>
                </div>

                <p className="profile-role-region">
                  {data?.role} at Insytix{data?.region}
                </p>
              </Fragment>
            );
          })}
        </div>
        <div style={{display:"flex", gap:"2rem"}}>

        <div className="my-own-details">
          <Button onClick={() => navigate("payslip")} style={{padding:"6px 50px"}}>
           Payslip
          </Button>
        </div>
        <div className="my-own-details">
          <Button onClick={() => navigate("employeeDetails")}>
            Enter Your Details
          </Button>
        </div>
        </div>
      </div>
      {user?.map((data: any) => {
        return (
          <>
            <div className="cards-main">
              <Card className="cards-profile">
                <table className="table-edit-content ">
                  <tr>
                    <th className="prof-tab">Name:</th>
                    <td className="prof-tab">
                      {data?.first_name + " " + data?.last_name}
                    </td>
                  </tr>
                  <tr>
                    <th className="prof-tab">Email:</th>
                    <td className="prof-tab">{data?.email}</td>
                  </tr>

                  <tr>
                    <th className="prof-tab">Phone:</th>
                    <td className="prof-tab">{data?.phone}</td>
                  </tr>
                </table>
                <div className="edit-button">
                  <Button onClick={handleShow}>Edit Profile</Button>
                </div>
                <Modal show={show} onHide={handleClose} backdrop="static">
                  <Modal.Header closeButton>
                    <Modal.Title>Edit Profile</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                      >
                        <div className="email-input">First Name</div>
                        <Form.Control
                          type="text"
                          placeholder="First Name"
                          autoFocus
                          {...register("first_name", {
                            required: {
                              value: true,
                              message: "This is required",
                            },
                          })}
                          defaultValue={data?.first_name}
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                      >
                        <div className="email-input">Last Name</div>
                        <Form.Control
                          type="text"
                          placeholder="Last Name"
                          autoFocus
                          {...register("last_name", {
                            required: {
                              value: true,
                              message: "This is required",
                            },
                          })}
                          defaultValue={data?.last_name}
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                      >
                        <div className="email-input">Phone Number</div>
                        <Form.Control
                          type="text"
                          placeholder="Phone Number"
                          autoFocus
                          {...register("phone", {
                            required: {
                              value: true,
                              message: "This is required",
                            },
                          })}
                          defaultValue={data?.phone}
                        />
                      </Form.Group>
                      <Modal.Footer>
                        <div className="edit-button-main">
                          <Button variant="primary" type="submit">
                            Save Changes
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Form>
                  </Modal.Body>
                </Modal>
              </Card>
            </div>
          </>
        );
      })}
     
    </MyProfileSc>
  );
}

export default Index;
